{
	"banner": {
		"acceptAll": "Accept all",
		"customise": "Customise",
		"policy": "Cookie Policy",
		"rejectAll": "Necessary only",
		"save": "Save",
		"text": "Cookies help us improve IEC and tailor content to you.",
		"title": "Make IEC yours"
	},
	"categories": {
		"advertising": {
			"hint": "Better personalisation of content, including ads.",
			"label": "Personalisation"
		},
		"analytics": {
			"hint": "Helps us see what works and what to improve.",
			"label": "Service improvement"
		},
		"necessary": {
			"hint": "Sign-in, security and your settings. Always on.",
			"label": "Essential"
		}
	},
	"error": "Your choice could not be saved. Please try again.",
	"offer": {
		"allow": "Allow",
		"decline": "Not now",
		"text": "Let us tailor content to you, including ads.",
		"title": "Content picked for you"
	},
	"att": {
		"continue": "Continue",
		"text": "Allow personalisation, and we'll tailor content to you, including ads. iOS will ask next."
	}
}
